import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import HLSVideo from '../../libs/hlsVideo';


const CONTENT_ITEMS = [
    {
        title: { ko: '유니티 6 완벽 지원', en: 'Full Support for Unity 6' },
        description: {
        ko: 'UModeler X는 최신 유니티 6까지 완벽하게 호환되며, 최적화된 워크플로우와 안정적인 성능을 제공합니다. 향상된 렌더링과 빠른 로딩 속도로 더욱 효율적인 3D 모델링 작업이 가능합니다.',
        en: 'UModeler X is fully compatible with the latest Unity 6,  providing optimized workflows and stable performance.  Experience enhanced rendering and fast loading speeds for more efficient 3D modeling.',
        },
        video: require("../../assets/un_01.webp"),
        reverse: false
    },
    {
        title: { ko: '유니티의 강력한 렌더링과 물리 엔진', en: (<>{'Utilize Unity’s Robust'}<br />{'Rendering and Physics Engine'}</>) },
        description: {
        ko: '유니티의 강력한 렌더링 기술과 물리 엔진을 활용하여 더욱 사실적인 비주얼과 자연스러운 동작을 구현하세요. 고품질 그래픽과 정밀한 물리 시뮬레이션을 통해 3D 모델과 애니메이션의 완성도를 한층 높일 수 있습니다.',
        en: 'Leverage Unity\'s powerful rendering and physics engine to bring  3D models to life with realistic animations and dynamic simulations. Achieve stunning graphics and precise physics for more immersive  and interactive 3D experiences.',
        },
        video: "m3u8/un_02.m3u8",
        thum: require("../../assets/thumnails/un_02_thum.webp"),
        reverse: true
    },
    {
        title: { ko: '유니티의 다양한 기능을 함께 활용', en: 'Leverage Unity\'s Diverse Features' },
        description: {
        ko: '유니티 클라우드를 통해 실시간으로 협업하고, 에셋 스토어의 다양한 리소스를 활용하세요.또한, VR/AR 지원 또는 Pixyz를 활용하여 모델을 Unity로 가져와 UModeler X에서 직접 편집할 수 있습니다.',
        en: 'Collaborate in real-time through Unity Cloud,  and access other products from the Asset Store. Use VR/AR support or, via Pixyz, import models into Unity and edit them directly with UModeler X.'},
        video: require("../../assets/un_03.webp"),
        reverse: false
    },
    {
        title: { ko: '유니티에서 외부 모델 즉시 편집', en: 'Edit External Models in Unity' },
        description: {
        ko: '유니티에서 불러온 모든 3D 모델 데이터를 즉시 편집하여 효율적인 작업을 경험하세요. 다양한 파일 형식을 지원하며, 모델의 형태 수정, 텍스처 및 머티리얼 적용, 애니메이션 조정까지 실시간으로 가능해 개발 시간을 단축하고 생산성을 높일 수 있습니다.',
        en: 'Edit all 3D model data imported into Unity quickly for efficient workflows.  Support a variety of file formats and easily adjust model shapes,  apply textures, and assign materials. Real-time animation adjustments are  also possible, reducing development time and increasing productivity.'
        },
        video: "m3u8/un_04.m3u8",
        thum: require("../../assets/thumnails/un_04_thum.webp"),
        reverse: true
    }
];

export default function Intergration() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);

    const [supBtnHover, setSupBtnHover] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {

    }, []);
    
    
    return (
        <>
            <div className="main_back">
                <div className="main_part padding">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? '유니티 통합환경' : 'Unity Intergration'}
                        </p>
                        <span className="sub_title">
                            {lang === 0 ? '유니티 에디터에서 익숙하고 편리하게 작업하세요. ' : 'Work seamlessly and efficiently within the Unity editor for a streamlined creative process.'}
                        </span>
                    </div>

                    {/* 콘텐츠 섹션 */}
                    <div className="header_page_content_box">
                        {CONTENT_ITEMS.map((item, index) => {
                        return (
                            <div className={`content ${item.reverse ? 'end' : ''}`} key={index}>
                            {item.reverse ? (
                                <>
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                {index === 0 || index === 2 ?
                                <div className="img_box_169" >
                                    <img src={item.video} alt={`content-${index}`} />
                                </div>
                                :
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>}
                                </>
                            ) : (
                                <>
                                {index === 0 || index === 2 ?
                                <div className="img_box_169" >
                                    <img src={item.video} alt={`content-${index}`} />
                                </div>
                                :
                                <div className="img_box">
                                    <HLSVideo
                                        width="100%"
                                        height="100%"
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        poster={item.thum}
                                        src={item.video}
                                    >
                                        소개 영상입니다.
                                    </HLSVideo>
                                </div>}
                                <div className="title_box">
                                    <p>{lang === 0 ? item.title.ko : item.title.en}</p>
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                    {lang === 0 ? item.description.ko : item.description.en}
                                    </span>
                                </div>
                                </>
                            )}
                            </div>
                        );
                        })}
                    </div>
                </div>

                <div className="page_start_banner">
                    <div className="content">
                        <p className="title">
                            {lang === 0 ? 
                                <>
                                    유니티 에디터에 최적화된 3D 작업
                                </>
                                :
                                <>
                                    Optimized 3D Workflow in the Unity Editor
                                </>
                            }
                        </p>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '무료로 써보기' : 'Try for Free'}
                            </button>
                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                style={{width: 220,}}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '문의하기' : 'Contact Us'}
                            </button>
                        </div>
                    </div>
                </div>
                
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
